import { useTranslation } from '@portals-platform/i18n';

interface FieldTextKeys {
  labelKey: string;
  placeholderKey?: string | undefined;
}

export function useFieldText({ labelKey, placeholderKey }: FieldTextKeys): {
  label: string;
  placeholder: string | undefined;
} {
  const { t } = useTranslation();

  return {
    label: t(labelKey),
    placeholder: placeholderKey ? t(placeholderKey) : undefined,
  };
}
